import { Validator } from "../validator"

export enum StreetNameError {
    BLANK = `street_name_error`,
}

class StreetNameValidator implements Validator<string, StreetNameError> {
    validate(entry: string): StreetNameError | undefined {
        if (entry === ``) {
            return StreetNameError.BLANK
        }
    }
}

export { StreetNameValidator }